export default __webpack_public_path__ + "static/media/Doom.7e692311.jpg";